import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ClickAndKeydownDirective } from '@directives/click-and-keydown.directive';
import { TranslateModule } from '@ngx-translate/core';

export interface IMessageBoxArgs {
    translatedTitleText: string;
    translatedMessageText: string;
}

@Component({
    selector: 'message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.less'],
    imports: [MatIconButton, MatDialogClose, MatIcon, MatButton, ClickAndKeydownDirective, TranslateModule]
})
export class MessageBoxComponent {
    dialogRef = inject<MatDialogRef<MessageBoxComponent>>(MatDialogRef);
    args = inject<IMessageBoxArgs>(MAT_DIALOG_DATA);


    ok(): void {
        this.dialogRef.close(true);
    }
}
